import { API_URL } from '@constants';

import {
	getClientId,
	getPlatform,
} from '@utils';

import { EAppId } from '../../../../../enums/EAppId';
import { getReferer } from '../../../../../utils/getReferer';
import { BaseApi } from '../../../BaseApi';

import { IFounderClientInfoRecord, IStatParamsApi } from './types';

export class BaseStatApi extends BaseApi {

	async sendStat(params: IStatParamsApi) {
		const data: IFounderClientInfoRecord = {
			/* eslint-disable @typescript-eslint/camelcase */
			action: params.action,
			url: params.url,
			user_id: params.userId,
			app_id: `${params.appId || EAppId.UNSET}:${getPlatform()}`,
			from_id: getClientId(),
			referer: getReferer(),
			user_agent: navigator.userAgent,
			/* eslint-enable @typescript-eslint/camelcase */

			data0: params.data0 || '',
			data1: params.data1 || '',
			data2: params.data2 || '',
			data3: params.data3 || '',
			data4: params.data4 || '',
			data5: params.data5 || '',
			data6: params.data6 || '',
			data7: params.data7 || '',
			data8: params.data8 || '',
			data9: params.data9 || '',
		};

		return this.post<{}, null>({
			url: API_URL.STAT_CLIENT_INFO,
			headers: {
				'Content-Type': 'application/json',
			},
			isNoProcessData: true,
			data: [[...Object.values(data)]],
		});
	}

}
